import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const AddPR_ExchangeInformationItemAdministrativeCosts = createAsyncThunk(
  "ExchangeInformationItemAdministrativeCosts/AddPR_ExchangeInformationItemAdministrativeCosts",
  async (Parameter, { rejectWithValue }) => {
    console.log("sdsdssaccascdsdsdsd");
    
    try {
      
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExchangeInformationItemAdministrativeCosts/AddPR_ExchangeInformationItemAdministrativeCosts",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const DeletePR_ExchangeInformationItemAdministrativeCosts = createAsyncThunk(
    "ExchangeInformationItemAdministrativeCosts/DeletePR_ExchangeInformationItemAdministrativeCosts",
    async (Parameter, { rejectWithValue }) => {
      console.log("sdsdssaccascdsdsdsd");
      
      try {
        
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/PR_ExchangeInformationItemAdministrativeCosts/DeletePR_ExchangeInformationItemAdministrativeCosts",Parameter
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const GetPR_ExchangeInformationItemAdministrativeCostsByID = createAsyncThunk(
    "ExchangeInformationItemAdministrativeCosts/GetPR_ExchangeInformationItemAdministrativeCostsByID",
    async (Parameter, { rejectWithValue }) => {
      console.log("sdsdssaccascdsdsdsd");
      
      try {
        
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/PR_ExchangeInformationItemAdministrativeCosts/GetPR_ExchangeInformationItemAdministrativeCostsByID",Parameter
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const ValidationExchangeInformationItemAdministrativeCosts = createAsyncThunk(
    "ExchangeInformationItemAdministrativeCosts/ValidationExchangeInformationItemAdministrativeCosts",
    async (Parameter, { rejectWithValue }) => {
      console.log("sdsdssaccascdsdsdsd");
      
      try {
        
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/FinancialSummary/GetFinancialSummaryForAdminstrtetive",Parameter
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


const ExchangeInformationItemAdministrativeCostsReducer = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    AddExchangeInformation: [],
    loadingAddExchangeInformation: false,
    errorAddExchangeInformation: null,
    //////////////////////////////////////////////
    DeleteExchangeInformation: [],
    loadingDeleteExchangeInformation: false,
    errorDeleteExchangeInformation: null,
    //////////////////////////////////////////////
    ExchangeInformationItemAdministrativeCosts: [],
    loadingExchangeInformationItemAdministrativeCosts: false,
    errorExchangeInformationItemAdministrativeCosts: null,
    //////////////////////////////////////////////
    ValidationExchangeInformationItemAdministrativeCosts: [],
    loadingValidationExchangeInformationItemAdministrativeCosts: false,
    errorValidationExchangeInformationItemAdministrativeCosts: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddPR_ExchangeInformationItemAdministrativeCosts.pending, (state, action) => {
        state.loadingAddExchangeInformation = true;
        state.AddExchangeInformation = action.payload;
        state.errorAddExchangeInformation = null;
      })
      .addCase(AddPR_ExchangeInformationItemAdministrativeCosts.fulfilled, (state, action) => {
        state.loadingAddExchangeInformation = false;
        state.AddExchangeInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddPR_ExchangeInformationItemAdministrativeCosts.rejected, (state, action) => {
        state.loadingAddExchangeInformation = false;
        state.errorAddExchangeInformation = action.payload;
      });
      //////////////////////////////////////////////////////////////////////
      builder
      .addCase(DeletePR_ExchangeInformationItemAdministrativeCosts.pending, (state, action) => {
        state.loadingDeleteExchangeInformation = true;
        state.DeleteExchangeInformation = action.payload;
        state.errorDeleteExchangeInformation = null;
      })
      .addCase(DeletePR_ExchangeInformationItemAdministrativeCosts.fulfilled, (state, action) => {
        state.loadingDeleteExchangeInformation = false;
        state.DeleteExchangeInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeletePR_ExchangeInformationItemAdministrativeCosts.rejected, (state, action) => {
        state.loadingDeleteExchangeInformation = false;
        state.errorDeleteExchangeInformation = action.payload;
      });
      //////////////////////////////////////////////////////////////////////
      builder
      .addCase(GetPR_ExchangeInformationItemAdministrativeCostsByID.pending, (state, action) => {
        state.loadingExchangeInformationItemAdministrativeCosts = true;
        state.ExchangeInformationItemAdministrativeCosts = action.payload;
        state.errorExchangeInformationItemAdministrativeCosts = null;
      })
      .addCase(GetPR_ExchangeInformationItemAdministrativeCostsByID.fulfilled, (state, action) => {
        state.loadingExchangeInformationItemAdministrativeCosts = false;
        state.ExchangeInformationItemAdministrativeCosts = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetPR_ExchangeInformationItemAdministrativeCostsByID.rejected, (state, action) => {
        state.loadingExchangeInformationItemAdministrativeCosts = false;
        state.errorExchangeInformationItemAdministrativeCosts = action.payload;
      });
      //////////////////////////////////////////////////////////////////////
      builder
      .addCase(ValidationExchangeInformationItemAdministrativeCosts.pending, (state, action) => {
        state.loadingValidationExchangeInformationItemAdministrativeCosts = true;
        state.ValidationExchangeInformationItemAdministrativeCosts = action.payload;
        state.errorValidationExchangeInformationItemAdministrativeCosts = null;
      })
      .addCase(ValidationExchangeInformationItemAdministrativeCosts.fulfilled, (state, action) => {
        state.loadingValidationExchangeInformationItemAdministrativeCosts = false;
        state.ValidationExchangeInformationItemAdministrativeCosts = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidationExchangeInformationItemAdministrativeCosts.rejected, (state, action) => {
        state.loadingValidationExchangeInformationItemAdministrativeCosts = false;
        state.ValidationExchangeInformationItemAdministrativeCosts = action.payload;
      });
  },
});

export default ExchangeInformationItemAdministrativeCostsReducer.reducer;
